import {AwsEmailTemplateDetails} from '@core/services/api-client.generated';
import {schema} from 'normalizr';

export interface IEmailTemplate extends AwsEmailTemplateDetails {}

export const emailTemplateSchema = new schema.Entity<IEmailTemplate>(
  'emailTemplates',
  {}
);

